<template>
    <div class="page-table  mainDiv " id="affix-container">
        <el-col :span="24" class="animated fadeInUp">
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="kisiselIslemListesi">Kişinin işlem Listesi
            </el-button>
            <el-button size="small" type="success" style="margin-top: 15px;"
                       @click="tumIslemListesi">Tüm işlem Listesi
            </el-button>
        </el-col>
    </div>
</template>

<script>
    import islemService from '../../../WSProvider/IslemService';
    import notification from '../../../notification'

    let base64 = require('base64_js');
    let userDataKader = "";
    export default {
        name: "IslemDetay",
        methods: {
            kisiselIslemListesi() {
                islemService.kisiselIslemListesi(0, 10);
            },
            tumIslemListesi() {
                islemService.tumIslemListesi(0, 20);
            }
        }
    }
</script>

<style scoped>

</style>